import { InkChip } from '@movable/ui';
import { Tooltip } from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

const TOOLTIP_TEXT =
  'This feature is still being developed, tested, and evaluated and, as a result, may experience issues and is subject to change based on feedback.';

interface BetaTagProps {
  /** Overrides merged over the default chip styles (e.g. its margin). */
  sx?: SxProps<Theme>;
}

/** Small "BETA" pill for flagging in-progress features. Wrap it next to a title or label. */
const BetaTag = ({ sx }: BetaTagProps) => (
  <Tooltip title={TOOLTIP_TEXT} arrow placement="top">
    <span>
      <InkChip
        maxWidth={null}
        chipProps={{
          size: 'small',
          color: 'info',
          variant: 'contrastFilled',
          label: 'BETA',
          sx: {
            fontWeight: 400,
            letterSpacing: '0.16px',
            margin: '0 4px 4px 8px',
            ...sx,
          },
        }}
      />
    </span>
  </Tooltip>
);

export default BetaTag;
